import React, { useState } from "react";
import axios from "axios";

const User = ({ setcurrent, setDataUser, dataUser, isValidUserError, isValidUser, setValidateCurrent, validateCurrent, dataCompany }) => {
    const [firstPass, setFirstPass] = useState(true);
    const [exist, setExist] = useState(false);

    function handleChange({ target }) {
        setFirstPass(false);
        setExist(false);
        const { name, value } = target;
        setDataUser({
            ...dataUser,
            [name]: value,
        });
    }

    const error = "h-8 bg-white border border-shippify-red rounded-lg outline-none mt-1 text-shippify-darkGray text-sm px-2 w-full";
    const check = "h-8 bg-white border rounded-lg outline-none mt-1 text-shippify-darkGray text-sm px-2 w-full";

    async function validate() {
        if (isValidUser) {
            // var exist = await axios.get(`http://localhost:8030/users/exist?email=${dataUser.email}&phone=${dataUser.phone}`);
            var exist = await axios.get(`https://dash.shippify.co/users/exist?email=${dataUser.email}&phone=${dataUser.phone}`);

            if (exist.data.message === "User exist") {
                setExist(true);
                setValidateCurrent({
                    ...validateCurrent,
                    user: false,
                });
            } else {
                setExist(false);
                if (isValidUser) {
                    setValidateCurrent({
                        ...validateCurrent,
                        user: true,
                    });
                }
                setcurrent("loading");
                done();
            }
        } else {
            setFirstPass(false);
        }
    }

    function done() {
        var data = {
            company_name: dataCompany.name,
            company_country: dataCompany.city,
            user_name: dataUser.name,
            user_email: dataUser.email,
            password: dataUser.password,
            user_phone: dataUser.phone,
            company_category: dataCompany.category,
            delivery_month: dataCompany.delivery,
            has_credit: true,
            subscriptionId: 13,
            stripeInfo: {},
            generalSignup: {
                parent_id: 3411,
                payment_method: 1,
            },
        };
        axios
            // .post(`http://localhost:8030/companies/saas`, data)
            .post(`https://dash.shippify.co/companies/saas`, data)
            .then((response) => {
                setcurrent("done");
            })
            .catch((err) => console.error("err", err));
    }
    return (
        <div className="h-form flex justify-between flex-col fade-in">
            <div className="flex flex-col">
                <div className="flex flex-col mt-4">
                    <div className="flex flex-col">
                        <span className="text-xs text-shippify-gray"> Admin name </span>
                        <input
                            type="text"
                            className={!firstPass && isValidUserError.name ? error : check}
                            name="name"
                            onChange={(e) => handleChange(e)}
                            value={dataUser.name}
                        />
                        <span className="text-shippify-red text-xs visible h-4 leading-none mt-1">{!firstPass && isValidUserError.name}</span>
                    </div>
                </div>
                <div className="flex flex-col">
                    <div className="grid grid-columns-2 grid-gap-4 flex-row w-full">
                        <div className="flex flex-col">
                            <span className="text-xs text-shippify-gray"> Email </span>
                            <input
                                type="text"
                                className={(!firstPass && isValidUserError.email) || exist ? error : check}
                                name="email"
                                onChange={(e) => handleChange(e)}
                                value={dataUser.email}
                            />
                            <span className="text-shippify-red text-xs visible h-4 leading-none mt-1">
                                {!firstPass && isValidUserError.email}
                                {exist && `Email already exist`}
                            </span>
                        </div>
                        <div className="flex flex-col">
                            <span className="text-xs text-shippify-gray"> Phone </span>
                            <input
                                type="text"
                                className={(!firstPass && isValidUserError.phone) || exist ? error : check}
                                name="phone"
                                onChange={(e) => handleChange(e)}
                                value={dataUser.phone}
                            />
                            <span className="text-shippify-red text-xs visible h-4 leading-none mt-1">
                                {!firstPass && isValidUserError.phone}
                                {exist && `Phone already exist`}
                            </span>
                        </div>
                    </div>
                </div>
                <div className="flex">
                    <div className="flex flex-col w-full">
                        <div className="flex flex-col">
                            <span className="text-xs text-shippify-gray"> Password </span>
                            <input
                                type="password"
                                className={!firstPass && isValidUserError.password ? error : check}
                                name="password"
                                onChange={(e) => handleChange(e)}
                                value={dataUser.password}
                            />
                            <span className="text-shippify-red text-xs visible h-4 leading-none mt-1">{!firstPass && isValidUserError.password}</span>
                        </div>
                        <div className="flex flex-col">
                            <span className="text-xs text-shippify-gray"> Confirm password </span>
                            <input
                                type="password"
                                className={!firstPass && isValidUserError.passwordConfirm ? error : check}
                                name="passwordConfirm"
                                onChange={(e) => handleChange(e)}
                                value={dataUser.passwordConfirm}
                            />
                            <span className="text-shippify-red text-xs visible h-4 leading-none mt-1">
                                {!firstPass && isValidUserError.passwordConfirm}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <div className="flex justify-between w-full">
                <div
                    className="rounded-full bg-white text-shippify-darkGray px-6 h-8 shadow-primary cursor-pointer flex justify-center items-center "
                    onClick={() => setcurrent("company")}>
                    Previous step
                </div>

                <div
                    className="rounded-full bg-shippify-green text-white px-6 h-8 outline-none flex justify-center items-center cursor-pointer shadow-primary"
                    onClick={validate}>
                    Done
                </div>
            </div>
        </div>
    );
};
export default User;
